import { Controller } from "@hotwired/stimulus";

// Wizard-style quiz editor: only real questions render; "Add question"
// reveals the next card from a <template>, each card is removable.
// Field names use a running index — gaps after removal are fine, the
// server sanitizer drops blanks and re-packs.
export default class extends Controller {
  static targets = ["list", "template", "addButton", "programPrompt"];
  static values = { max: { type: Number, default: 5 } };

  connect() {
    this.nextIndex = this.listTarget.querySelectorAll("[data-quiz-editor-card]").length;
    this.refresh();
    this.programToggle = this.element.querySelector('input[type=checkbox][name="funnel_step[ask_program]"]');
    this.programToggle?.addEventListener("change", () => this.programToggled());
    this.programToggled();
  }

  // Quiz-level "ask about program?" — the prompt field only matters
  // when it's on.
  programToggled() {
    if (!this.programToggle || !this.hasProgramPromptTarget) return;
    this.programPromptTarget.hidden = !this.programToggle.checked;
  }

  add() {
    if (this.count() >= this.maxValue) return;
    const fragment = this.templateTarget.content.cloneNode(true);
    fragment.querySelectorAll("[name]").forEach((input) => {
      input.name = input.name.replace("__INDEX__", this.nextIndex);
    });
    this.listTarget.appendChild(fragment);
    this.nextIndex += 1;
    this.refresh();
    const card = this.listTarget.lastElementChild;
    card.scrollIntoView({ behavior: "smooth", block: "center" });
    card.querySelector("input[type=text]")?.focus();
  }

  remove(event) {
    event.currentTarget.closest("[data-quiz-editor-card]").remove();
    this.refresh();
  }

  count() {
    return this.listTarget.querySelectorAll("[data-quiz-editor-card]").length;
  }

  refresh() {
    // Renumber the visible labels, sync choices visibility, cap the add button.
    this.listTarget.querySelectorAll("[data-quiz-editor-card]").forEach((card, i) => {
      const label = card.querySelector("[data-quiz-editor-number]");
      if (label) label.textContent = `Question ${i + 1}`;
    });
    this.addButtonTarget.hidden = this.count() >= this.maxValue;
  }
}
